const debtVerificationIcon = '/images/debtVerification.svg';

export const debtVerificationData = {
  data: {
    id: 3,
    type: 'debt',
    icon: debtVerificationIcon,
    title: 'Debt Profile Verification',
    description: 'Please enter your BVN to verify your debt profile',
    value:
      'Please verify your debt profile to successfully complete your financial assessment',
    errorMessage:
      ' You currently have an active debt or loan in progress. Please complete your payments or clear your outstanding balance before you can access our platform. If you believe this is an error or need assistance, please contact our support team via chat, email or call. support@smallsmall.com, 02013306045',
  },
};
